import { render } from "./EditMedicationType.vue?vue&type=template&id=fdea1f9c&scoped=true"
import script from "./EditMedicationType.vue?vue&type=script&lang=js"
export * from "./EditMedicationType.vue?vue&type=script&lang=js"

import "./EditMedicationType.vue?vue&type=style&index=0&id=fdea1f9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdea1f9c"]])

export default __exports__